module.exports = __webpack_public_path__ + "static/media/dining_home.49c34a6b.png";